import { render, staticRenderFns } from "./referrer-receive-search.vue?vue&type=template&id=5a37fd99&scoped=true"
import script from "./referrer-receive-search.vue?vue&type=script&lang=js"
export * from "./referrer-receive-search.vue?vue&type=script&lang=js"
import style0 from "./referrer-receive-search.vue?vue&type=style&index=0&id=5a37fd99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37fd99",
  null
  
)

export default component.exports